import React from 'react';
import DateRangePicker from './DateRangePicker';

const Filter: React.FC = () => {
    return (
        <>
            {/*filter offcanvas*/}
            <div className="offcanvas offcanvas-end width-320" id="filter" data-bs-scroll="true" data-bs-backdrop="false">
                <div className="offcanvas-header border-bottom">
                    <div>
                        <h5 className="offcanvas-title" id="filterLable">Filter</h5>
                        <p className="text-secondary small">Customize your data</p>
                    </div>
                    <button type="button" className="btn-close" data-bs-dismiss="offcanvas"></button>
                </div>
                <div className="offcanvas-body">

                    <h6 className="offcanvas-title">Duration</h6>
                    <p className="text-secondary small">Select duration</p>
                    <div className='mb-3 mb-lg-4'>
                        <DateRangePicker />
                    </div>

                    <h6 className="offcanvas-title mb-3">Geographic Details</h6>
                    <div className="input-group input-group-md rounded mb-3 mb-lg-4" style={{ "--mw-dynamic": "calc(100% - 42px)" } as React.CSSProperties}>
                        <span className="input-group-text text-theme-1"><i className="bi bi-box"></i></span>
                        <select className="form-control choices" id="titltfilterlist" multiple defaultValue={["India"]}>
                            <option value="San Francisco">San Francisco</option>
                            <option value="New York">New York</option>
                            <option value="London">London</option>
                            <option value="Chicago">Chicago</option>
                            <option value="India">India</option>
                            <option value="Sydney">Sydney</option>
                            <option value="Seattle">Seattle</option>
                            <option value="Los Angeles">Los Angeles</option>
                            <option value="Indonesia">Indonesia</option>
                            <option value="Los Angeles">Los Angeles</option>
                            <option value="Chicago">Chicago</option>
                            <option value="India">India</option>
                        </select>
                    </div>

                    <h6 className="mb-3">Orders Type</h6>
                    <ul className="list-group bg-transparent mb-3 mb-lg-4">
                        <li className="list-group-item">
                            <div className="row gx-3 gx-lg-4">
                                <div className="col">Online Orders</div>
                                <div className="col-auto">
                                    <div className="form-check form-switch">
                                        <input className="form-check-input" type="checkbox" role="switch" id="titleswitch1" />
                                        <label className="form-check-label" htmlFor="titleswitch1"></label>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li className="list-group-item">
                            <div className="row gx-3 gx-lg-4">
                                <div className="col">Offline Orders</div>
                                <div className="col-auto">
                                    <div className="form-check form-switch">
                                        <input className="form-check-input" type="checkbox" role="switch" id="titleswitch2" defaultChecked />
                                        <label className="form-check-label" htmlFor="titleswitch2"></label>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>

                </div>
                <div className="offcanvas-footer p-3 border-top">
                    <div className="row gx-3 gx-lg-4">
                        <div className="col">
                            <button className="btn btn-theme">Save</button>
                        </div>
                        <div className="col-auto">
                            <a href="adminuiux-company-help-center.html" className="btn btn-link btn-square" data-bs-toggle="tooltip" data-bs-placement="top" id="stylise">
                                <i className="bi bi-life-preserver"></i>
                            </a>
                            <a href="https://1.envato.market/v37gj" target="_blank" className="btn btn-link btn-square" data-bs-toggle="tooltip" data-bs-placement="top">
                                <span className="bi bi-basket position-relative">
                                    <span className="position-absolute top-0 start-100 p-1 bg-danger border border-light rounded-circle">
                                        <span className="visually-hidden">New alerts</span>
                                    </span>
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Filter;
